import React, {memo, useCallback, useMemo, useState} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {useSelector} from "react-redux"
import {SIPBlockedNumbersState} from "../../../../store/control/state"
import {useLocalization} from "../../../../hooks/localization"
import {useMessage} from "../../../../hooks/message"
import {useRPC} from "../../../../hooks/rpc"
import {ColumnModel, SettingsList} from "../../../../components/Settings/SettingsList"

const keyExtractor = (item: SIPBlockedNumbersState) => item.id

export const SIPBlockedList = memo(function SIPBlockedList() {
    const {t} = useLocalization()
    const {success, failure} = useMessage()
    const [rpc] = useRPC()
    const blockedList = useSelector(state => state.control.callBlockList)
    const [selectedNumber, setSelectedNumber] = useState<SIPBlockedNumbersState>(null)

    const displayNameExtractor = useCallback((item: SIPBlockedNumbersState, column: ColumnModel) => {
        return item[column.key] || "-"
    }, [])

    const onClickDeleteNumber = useCallback(
        (id: string) => {
            rpc.deleteCallBlockNumber(id)
                .then(() => success(t("number_deleted_successfully")))
                .catch(failure)
        },
        [success, failure, t, rpc]
    )

    const columns = useMemo<ColumnModel[]>(
        () => [
            {
                length: 2,
                name: t("flat_name"),
                key: "name"
            },
            {
                length: 3,
                name: t("blocked_number"),
                key: "number"
            },
            {
                length: 2,
                name: t("blocked_count"),
                key: "blocked_count"
            }
        ],
        [t]
    )
    const buttons = useMemo(
        () => [
            {
                text: t("block_new_number"),
                className: "green",
                url: "/settings/intercom/blocked-list/add-number"
            },
            {
                text: t("delete"),
                className: "red",
                onClick: () => onClickDeleteNumber(selectedNumber?.id),
                hidden: !selectedNumber
            }
        ],
        [t, selectedNumber, onClickDeleteNumber]
    )

    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} className="device-list-page" backUrl={"/settings/intercom"}>
                <SettingsList
                    columns={columns}
                    items={blockedList}
                    listType="sipBlockedList"
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedNumber}
                    onItemSelected={setSelectedNumber}
                />
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
